import React, { createContext, useState } from 'react';

import type { SidebarContextType } from '../types';

export const SidebarContext = createContext<SidebarContextType | null>(null);

export const SidebarProvider = ({ children = undefined }: React.PropsWithChildren<{}>) => {
  const [sidebar, setSidebar] = useState<React.ReactElement | null>(null);

  const clearSidebar = () => {
    setSidebar(null);
  };

  return <SidebarContext.Provider value={{ sidebar, clearSidebar, setSidebar }}>{children}</SidebarContext.Provider>;
};
